import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18n from './i18n';
import 'flag-icons/css/flag-icons.min.css';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import './components/ScrollToTopButton.css';
import { ChatProvider } from './context/ChatContext'; 
import ChatWidget from './components/ChatWidget';
import './components/Chat.css'; 
import NotificationWidget from './components/NotificationWidget';

import { AuthProvider, useAuth } from './context/AuthContext';
import { countryData, supportedLanguages } from './data/countries';
import AccordionTestPage from './pages/admin/AccordionTestPage';
import './App.css';
import './components/Header.css';
import './components/LandingPage.css';
import './components/Footer.css'; 
import './components/LanguageSwitcher.css';
import './components/AuthPages.css';
import './components/AuthModal.css';

import Header from './components/Header';
import LandingPage from './components/LandingPage';
import Footer from './components/Footer';
import OrderPage from './components/OrderPage';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import ProtectedRoute from './components/ProtectedRoute';
import TranslatorRegisterPage from './pages/TranslatorRegisterPage';
import CustomerOrdersPage from './pages/account/CustomerOrdersPage';
import TranslatorJobsPage from './pages/dashboard/TranslatorJobsPage';
import JobDetailPage from './pages/dashboard/JobDetailPage';
import AvailableJobsPage from './pages/dashboard/AvailableJobsPage';
import ProfilePage from './pages/dashboard/ProfilePage';
import CustomerProfilePage from './pages/account/CustomerProfilePage';
import SupportProfilePage from './pages/support/SupportProfilePage';
import CreateQuotePage from './pages/support/CreateQuotePage';
import SupportPendingJobsPage from './pages/support/SupportPendingJobsPage';
import AllJobsPage from './pages/support/AllJobsPage'; 
import UserManagementPage from './pages/admin/UserManagementPage';
import AdminDashboardLayout from './pages/admin/AdminDashboardLayout';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

import './pages/dashboard/Dashboard.css'; 
import './pages/support/Support.css';    
import './pages/admin/Admin.css'; 
import CustomerOrderDetailPage from './pages/account/CustomerOrderDetailPage';
import ReviewJobsPage from './pages/support/ReviewJobsPage';
import SupportJobDetailPage from './pages/support/SupportJobDetailPage';

import AdminStatsPage from './pages/admin/AdminStatsPage';
import PendingPayoutsPage from './pages/admin/PendingPayoutsPage';
import PendingTranslatorsPage from './pages/admin/PendingTranslatorsPage';
import AdminTranslatorDetailPage from './pages/admin/AdminTranslatorDetailPage';
import DiscountManagementPage from './pages/admin/DiscountManagementPage';
import CustomerDetailPage from './pages/admin/CustomerDetailPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import MembershipTermsPage from './pages/MembershipTermsPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import FaqPage from './pages/FaqPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import QuoteDetailPage from './pages/public/QuoteDetailPage';
import BannerManagementPage from './pages/admin/BannerManagementPage';

import AnnouncementBanner from './components/AnnouncementBanner';
function AppContent() {
  const { i18n } = useTranslation();
  const [currency, setCurrency] = useState('USD');
  const [timezone, setTimezone] = useState('Europe/Istanbul');
  const [initialSourceLang, setInitialSourceLang] = useState('en');
  const [isLoading, setIsLoading] = useState(true);
const [isBannerVisible, setIsBannerVisible] = useState(false);
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ip-api.com/json/?fields=status,message,countryCode,timezone');
        if (!response.ok) throw new Error(`API request failed: ${response.status}`);
        const data = await response.json();
        if (data.status !== 'success') throw new Error(data.message || 'API error');

        const userCountryCode = data.countryCode;
        const userTimezone = data.timezone;
        
        setTimezone(userTimezone || 'Europe/Istanbul');
        const countryInfo = countryData[userCountryCode];
        
        let finalLanguage = 'en';
        let finalCurrency = 'USD';
        let sourceLanguageForOrder = 'en';

        if (countryInfo) {
          if (supportedLanguages.includes(countryInfo.language)) {
            finalLanguage = countryInfo.language;
          }
          finalCurrency = countryInfo.currency;
          sourceLanguageForOrder = countryInfo.language;
        }
        
        if (finalLanguage === 'tr') {
          finalCurrency = 'TRY';
        }

        i18n.changeLanguage(finalLanguage);
        setCurrency(finalCurrency);
        setInitialSourceLang(sourceLanguageForOrder);
      } catch (error) {
       console.error("Could not fetch user location, using defaults.", error);
        // Hata durumunda varsayılanlar zaten state'lerde ayarlı.
      } finally {
        // DÜZELTME: isLoading, her durumda false'a çekiliyor.
        setIsLoading(false);
      }
    };

    fetchUserLocation();
  }, [i18n]); // Bağımlılığa i18n eklendi


  useEffect(() => {
    const currentLang = i18n.language.split('-')[0];
    if (currentLang === 'tr') {
      // Bu if bloğu gereksiz render'ları önlemek için kalabilir, sorun yaratmaz.
      if (currency !== 'TRY') {
        setCurrency('TRY');
      }
    }

  }, [i18n.language]); 



  return (
    <div className="App">
	<AnnouncementBanner onVisibilityChange={setIsBannerVisible}/>
      <Header isBannerVisible={isBannerVisible} selectedCurrency={currency} onCurrencyChange={setCurrency} />
      <main className="main-content" style={{ paddingTop: isBannerVisible ? '0' : '80px' }}>
        <div className="main-container">
          <Routes>
            {/* Public Rotalar */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/order" element={<OrderPage selectedCurrency={currency} initialTimezone={timezone} initialSourceLang={initialSourceLang} />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/register-translator" element={<TranslatorRegisterPage />} />
			<Route path="/forgot-password" element={<ForgotPasswordPage />} />
			<Route path="/reset-password/:token" element={<ResetPasswordPage />} />
			 <Route 
              path="/quote/:token" 
              element={<QuoteDetailPage selectedCurrency={currency} />} 
            />
            {/* Korumalı Çevirmen Rotaları */}
            <Route 
            path="/dashboard/jobs" 
            element={
              <ProtectedRoute allowedRoles={['translator']}>
                <TranslatorJobsPage selectedCurrency={currency} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/jobs/:jobId" 
            element={
              <ProtectedRoute allowedRoles={['translator']}>
                <JobDetailPage selectedCurrency={currency} />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/dashboard/available-jobs" 
            element={
              <ProtectedRoute allowedRoles={['translator']}>
                <AvailableJobsPage selectedCurrency={currency} />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/dashboard/profile" 
            element={
              <ProtectedRoute allowedRoles={['translator']}>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
            
            {/* Korumalı Müşteri Rotaları */}
           <Route 
            path="/account/orders" 
            element={
              <ProtectedRoute allowedRoles={['customer']}>
                {/* YENİ: selectedCurrency prop'u eklendi */}
                <CustomerOrdersPage selectedCurrency={currency} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/account/orders/:orderId" 
            element={<ProtectedRoute allowedRoles={['customer']}><CustomerOrderDetailPage selectedCurrency={currency} /></ProtectedRoute>} 
          />
		  <Route path="/account/profile" element={<ProtectedRoute allowedRoles={['customer']}><CustomerProfilePage /></ProtectedRoute>} />
            
           <Route 
              path="/management" 
              element={
                <ProtectedRoute allowedRoles={['admin', 'support']}>
                  <AdminDashboardLayout />
                </ProtectedRoute>
              }
            >
              {/* /management'a gelen kullanıcıları rollere göre doğru sayfaya yönlendir */}
              <Route index element={<RoleBasedRedirect />} /> 
              <Route 
                path="pending-jobs" 
                element={<SupportPendingJobsPage />} 
              />
              {/* Support ve Admin'in erişebileceği sayfalar */}
              <Route path="all-jobs" element={<AllJobsPage />} />
              <Route path="review-jobs" element={<ReviewJobsPage />} />
              <Route path="jobs/:jobId" element={<SupportJobDetailPage />} />
			  
              	<Route 
      path="create-quote" 
      element={
        <ProtectedRoute allowedRoles={['admin', 'support']}>
          <CreateQuotePage />
        </ProtectedRoute>
      } 
    />
	
              
              {/* Sadece Admin'in erişebileceği sayfalar */}
              <Route 
                path="user-management" 
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <UserManagementPage />
                  </ProtectedRoute>
                } 
              />
			  <Route 
      path="translators/:userId" 
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AdminTranslatorDetailPage />
        </ProtectedRoute>
      } 
    />
<Route 
      path="pending-payouts" 
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <PendingPayoutsPage />
        </ProtectedRoute>
      } 
    />

              <Route 
                path="statistics" 
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <AdminStatsPage />
                  </ProtectedRoute>
                } 
              />
			  <Route 
      path="pending-translators" 
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <PendingTranslatorsPage />
        </ProtectedRoute>
      } 
    />
	<Route 
      path="accordion-test" 
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AccordionTestPage />
        </ProtectedRoute>
      } 
    />

	  <Route 
                path="discounts" 
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <DiscountManagementPage />
                  </ProtectedRoute>
                } 
              />
   
  <Route 
      path="banners" 
      element={
        <ProtectedRoute allowedRoles={['admin']}>
          <BannerManagementPage />
        </ProtectedRoute>
      } 
    />


<Route 
    // DÜZELTME: "path" değeri göreceli hale getirildi.
    // Artık tam yolu "/management/customers/:customerId" olacak.
    path="customers/:customerId" 
    element={
        <ProtectedRoute allowedRoles={['admin']}>
            <CustomerDetailPage />
        </ProtectedRoute>
    } 
/>
            </Route>
			
			{/* YENİ STATİK SAYFA ROTALARI */}
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
		   <Route path="/faq" element={<FaqPage />} />
		   <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
		   <Route path="/terms-of-service" element={<TermsOfServicePage />} />
		   <Route path="/membership-terms" element={<MembershipTermsPage />} />
          </Routes>
        </div>
      </main>
	  <ChatWidget />
	  <NotificationWidget />
	   <Footer />
	   <ScrollToTopButton />
    </div>
  );
}

const RoleBasedRedirect = () => {
    const { user } = useAuth();
    if (!user) return null;
    if (user.role === 'admin') {
        return <Navigate to="/management/user-management" replace />;
    }
    if (user.role === 'support') {
        return <Navigate to="/management/all-jobs" replace />;
    }
    return <Navigate to="/" replace />;
};

function App() {
  return (
    <AuthProvider>
      <ChatProvider> {/* YENİ: AuthProvider'ı sarmala */}
        <I18nextProvider i18n={i18n}>
          <BrowserRouter>
		  <ScrollToTop />
            <AppContent />
          </BrowserRouter>
        </I18nextProvider>
      </ChatProvider>
    </AuthProvider>
  );
}


export default App;